import React, { useState, useEffect, useCallback } from "react";
import { CloseButton, Form, InputGroup, Button } from "react-bootstrap";
import axios from 'axios';
import { getSessionStorage } from '../../assets/constant';

const WEEKS = Array.from({ length: 15 }, (_, i) => i + 1);
const SESSIONS = [1, 2, 3];

const QrType = {
  SESSION_1: '[1주차 1차시]',
  SESSION_2: '[1주차 2차시]',
  SESSION_3: '[1주차 3차시]',
  SESSION_4: '[2주차 1차시]',
  SESSION_5: '[2주차 2차시]',
  SESSION_6: '[2주차 3차시]',
  SESSION_7: '[3주차 1차시]',
  SESSION_8: '[3주차 2차시]',
  SESSION_9: '[3주차 3차시]',
  SESSION_10: '[4주차 1차시]',
  SESSION_11: '[4주차 2차시]',
  SESSION_12: '[4주차 3차시]',
  SESSION_13: '[5주차 1차시]',
  SESSION_14: '[5주차 2차시]',
  SESSION_15: '[5주차 3차시]',
  SESSION_16: '[6주차 1차시]',
  SESSION_17: '[6주차 2차시]',
  SESSION_18: '[6주차 3차시]',
  SESSION_19: '[7주차 1차시]',
  SESSION_20: '[7주차 2차시]',
  SESSION_21: '[7주차 3차시]',
  SESSION_22: '[8주차 1차시]',
  SESSION_23: '[8주차 2차시]',
  SESSION_24: '[8주차 3차시]',
  SESSION_25: '[9주차 1차시]',
  SESSION_26: '[9주차 2차시]',
  SESSION_27: '[9주차 3차시]',
  SESSION_28: '[10주차 1차시]',
  SESSION_29: '[10주차 2차시]',
  SESSION_30: '[10주차 3차시]',
  SESSION_31: '[11주차 1차시]',
  SESSION_32: '[11주차 2차시]',
  SESSION_33: '[11주차 3차시]',
  SESSION_34: '[12주차 1차시]',
  SESSION_35: '[12주차 2차시]',
  SESSION_36: '[12주차 3차시]',
  SESSION_37: '[13주차 1차시]',
  SESSION_38: '[13주차 2차시]',
  SESSION_39: '[13주차 3차시]',
  SESSION_40: '[14주차 1차시]',
  SESSION_41: '[14주차 2차시]',
  SESSION_42: '[14주차 3차시]',
  SESSION_43: '[15주차 1차시]',
  SESSION_44: '[15주차 2차시]',
  SESSION_45: '[15주차 3차시]',
};

const getQrTypeKey = (week, session) => `SESSION_${(week - 1) * 3 + session}`;

const QrCreatePopup = ({setVisibleQrCreatePopup, courseId}) => {
  const [selectedWeek, setSelectedWeek] = useState(1);
  const [selectedSession, setSelectedSession] = useState(1);
  const [sessionAssignments, setSessionAssignments] = useState([]);
  const [selectedAssignmentId, setSelectedAssignmentId] = useState('');
  const [validStart, setValidStart] = useState("");
  const [validEnd, setValidEnd] = useState("");
  const [loading, setLoading] = useState(false);
  const [qrResult, setQrResult] = useState(null);

  const closePopup = () => {
    setVisibleQrCreatePopup(false);
  };

  const fetchSessionAssignments = useCallback(async (week, session) => {
    try {
      const token = getSessionStorage();
      const res = await axios.get(
        `${process.env.REACT_APP_SERVER}/qr/sessions?courseId=${courseId}&week=${week}&session=${session}`,
        { headers: token ? { Authorization: `Bearer ${token}` } : {} }
      );
      const data = res.data?.data ?? res.data ?? [];
      setSessionAssignments(data);
      setSelectedAssignmentId('');
    } catch (err) {
      setSessionAssignments([]);
      setSelectedAssignmentId('');
    }
  }, [courseId]);

  useEffect(() => {
    fetchSessionAssignments(selectedWeek, selectedSession);
  }, [selectedWeek, selectedSession, fetchSessionAssignments]);

  const handleCreateQr = async () => {
    if (!validStart || !validEnd) {
      alert("유효기간을 입력해 주세요");
      return;
    }
    if (new Date(validEnd) < new Date(validStart)) {
      alert("종료 시간이 시작 시간보다 이르게 입력되어 있습니다.");
      return;
    }
    if (sessionAssignments.length >= 1 && !selectedAssignmentId) {
      alert("과제를 선택해 주세요");
      return;
    }

    try {
      setLoading(true);

      const qrTypeKey = getQrTypeKey(selectedWeek, selectedSession);
      const payload = {
        courseId: courseId,
        qrType: qrTypeKey,
        assignmentId: selectedAssignmentId ? Number(selectedAssignmentId) : null,
        startAt: validStart,
        endAt: validEnd,
      };
      const access = getSessionStorage();
      const res = await axios.post(`${process.env.REACT_APP_SERVER}/qr/create/attendance`, payload, {
        headers: {
          Authorization: `Bearer ${access}`,
        },
      });

      const data = res?.data?.data ?? res?.data;
      setQrResult(data);
    } catch (e) {
      console.error(e);
      const msg = e?.response?.data?.message || e?.response?.data?.errorMessage;
      alert(msg || 'QR 생성 중 오류가 발생했습니다.');
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const selectedQrTypeKey = getQrTypeKey(selectedWeek, selectedSession);

  return (
    <>
      <div onClick={closePopup} className='backdrop w-100 h-100 position-fixed top-0 start-0' style={{ zIndex: '550' }}></div>
      <div
        className='bg-white position-fixed position-center p-4 rounded-2 popupContainer'
        style={{
          width: '90vw',
          maxWidth: '800px',
          maxHeight: '85vh',
          marginTop: '35px',
          overflowY: 'auto',
          zIndex: '600',
        }}
      >
        <div className="d-flex align-items-center justify-content-between">
          <h3 className="h2 text-gray1 fw-bold py-2 mb-3">
            {qrResult ? 'QR 코드 확인' : 'QR 코드 생성'}
          </h3>
          <CloseButton onClick={closePopup} style={{ fontSize: '24px' }} />
        </div>
        {!qrResult && (
          <>
            <div className="border border-start-0 border-end-0 d-flex align-items-center gap-3 py-2 mb-2">
              <h5 className="h2 text-gray1 fw-bold mb-0">주차시 선택</h5>
              <Form.Select
                style={{ width: '120px' }}
                value={selectedWeek}
                onChange={(e) => setSelectedWeek(Number(e.target.value))}
              >
                {WEEKS.map((w) => (
                  <option key={w} value={w}>{w}주차</option>
                ))}
              </Form.Select>
              <Form.Select
                style={{ width: '120px' }}
                value={selectedSession}
                onChange={(e) => setSelectedSession(Number(e.target.value))}
              >
                {SESSIONS.map((s) => (
                  <option key={s} value={s}>{s}차시</option>
                ))}
              </Form.Select>
            </div>

            {sessionAssignments.length >= 1 && (
              <div className="border border-start-0 border-end-0 d-flex align-items-center gap-3 py-2 mb-2">
                <h5 className="h2 text-gray1 fw-bold mb-0">과제 선택</h5>
                <Form.Select
                  style={{ width: '400px' }}
                  value={selectedAssignmentId}
                  onChange={(e) => setSelectedAssignmentId(e.target.value)}
                >
                  <option value="">-- 과제를 선택하세요 --</option>
                  {sessionAssignments.map((a) => (
                    <option key={a.id} value={a.id}>{a.name}</option>
                  ))}
                </Form.Select>
              </div>
            )}

            <div className="border border-start-0 border-end-0 d-flex align-items-center gap-3 py-2 mb-2">
              <h5 className="h2 text-gray1 fw-bold mb-0">유효 기간</h5>
              <InputGroup style={{ width: '600px' }}>
                <Form.Control
                  type="datetime-local"
                  value={validStart}
                  onChange={(e) => {
                    const v = e.target.value;
                    setValidStart(v);
                    if (validEnd && v && validEnd < v) setValidEnd('');
                  }}
                />
                <InputGroup.Text> ~ </InputGroup.Text>
                <Form.Control
                  type="datetime-local"
                  value={validEnd}
                  min={validStart}
                  onChange={(e) => setValidEnd(e.target.value)}
                />
              </InputGroup>
            </div>

            <div className="d-flex gap-2 mt-3">
              <Button
                onClick={handleCreateQr}
                disabled={loading || (sessionAssignments.length >= 1 && !selectedAssignmentId)}
              >
                {loading ? '생성 중...' : 'QR 생성'}
              </Button>
            </div>
          </>
        )}

        {qrResult && (
          <>
            <div className="d-flex flex-column align-items-center gap-3 py-3">
              {qrResult?.qrImage ? (
                <img
                  src={qrResult.qrImage}
                  alt="생성된 QR 코드"
                  style={{ width: 500, height: 500 }}
                />
              ) : (
                <div className="text-muted">QR 이미지가 없습니다.</div>
              )}

              <div className="w-100 border rounded p-3 bg-light">
                <div className="d-flex align-items-center gap-2 mb-2">
                  <span className="fw-bold">주차시:</span>
                  <span>{QrType[selectedQrTypeKey]}</span>
                </div>
                <div className="d-flex align-items-center gap-2">
                  <span className="fw-bold">유효기간:</span>
                  <span>
                    {(qrResult.startAt || validStart).replace('T', ' ')}
                    {' ~ '}
                    {(qrResult.endAt || validEnd).replace('T', ' ')}
                  </span>
                </div>
              </div>

              <Button variant="outline-secondary" onClick={closePopup}>
                닫기
              </Button>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default QrCreatePopup;
